export default __webpack_public_path__ + "media/images/home/slide_spring_2026_lg-5da3c83d2c59bd3e053e05cb8d1d1a29.png";